import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Main } from '../Main/Main';
import { Header } from '../Header/Header';
import { useAppSelector } from '../../../redux/hooks';
import { rootState } from '../../../redux/store';
import { UserProfileInfo } from '../../features/userProfile/UserProfileInfo';
import { ModalTimer } from '../../shared/Modal/ModalTimer/ModalTimer';
import { ModalLoading } from '../../shared/Modal/ModalLoading/ModalLoading';
import { ToolTip } from '../../features/ToolTip/ToolTip';
import { Chatbot } from '../../features/Chatbot/Chatbot';
import { ExpiredToken } from '../../shared/ExpiredToken/ExpiredToken';
import { ProtectedUsers } from '../../shared/ProtectedUsers/ProtectedUsers';
import { USERNAMES_DEV } from '../../../constants/constants';

export const RootLayout = () => {
    const { showUserDisplay } = useAppSelector((state: rootState) => state.userDisplay);
    const { logout, timer } = useAppSelector((state: rootState) => state.userLogout);
    const { louncherInstallerLoading } = useAppSelector((state: rootState) => state.louncherInstaller);
    const { mergingLoading } = useAppSelector((state: rootState) => state.mergingAvatar);

    return (
        <div className="root-container">
            {/* EXPIRED TOKEN */}
            {/* <ProtectedUsers protectedUsers={USERNAMES_DEV}>
                <ExpiredToken />
            </ProtectedUsers> */}

            {/* Show User Profile details */}
            {showUserDisplay && <UserProfileInfo />}

            {/* Show modal with timer when loging out */}
            {logout && <ModalTimer redirectTime={timer} redirectRoute={'/'} timer={true} label="Loging out" />}

            {/* Show modal download launcher */}
            {louncherInstallerLoading && <ModalLoading label={'Downloading Launcher'} />}

            {/* Show modal merging passengers */}
            {mergingLoading && <ModalLoading label={'Merging passengers'} />}

            <Chatbot />

            <ToolTip />
            <Header />
            <Main>
                <Outlet />
            </Main>
        </div>
    );
};
